import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui'
import { actions as operationActions } from 'ducks/uiOperations'
import { actions as formActions } from 'ducks/form'
import { selectors as documentSelector } from 'ducks/supplierEnquiry/attachments/documents'
import { fetch } from 'api/supplierEnquiry/attachments/documents'
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters'
import { selectors as supplierSelectors } from 'ducks/supplierEnquiry/supplier';


export const mapStateToProps = state => {
  const params = new URLSearchParams(location.search);

  return {
    gridName: 'SupplierEnquiryDocuments',
    columnDefs: documentSelector.columns(state),
    isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
    gridOptions: documentSelector.gridOptions(state),
    filterRow: documentSelector.filterRow(state),
    selectedFilters: documentSelector.selectedFilters(state),
    appliedFilters: documentSelector.filterRow(state) && filterSelectors.getFilters(state, documentSelector.filterRow(state).formName),
    reqParams: (supplierSelectors.selected(state) || params.get('Supplier'))
      &&
    {
      SupplierId: (supplierSelectors.selected(state) && supplierSelectors.selected(state).Supplier) || params.get('Supplier')
    },
    apiMethod: supplierSelectors?.selected(state)?.Supplier || params?.get('Supplier') ? fetch : () => Promise.resolve(null)
  }
};

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  applyFilters: filterActions.applyFilters
}
